import { createContext, ReactNode, useContext } from "react";

import { useFilterHotel } from "./filter-hotel.hook";

const FilterHotelContext = createContext(
  {} as ReturnType<typeof useFilterHotel>
);
export function useFilterHotelContext() {
  return useContext(FilterHotelContext);
}

interface FilterHotelProviderProps {
  children: ReactNode;
}
export function FilterHotelProvider({
  children,
}: FilterHotelProviderProps) {
  return (
    <FilterHotelContext.Provider value={useFilterHotel()}>
      {children}
    </FilterHotelContext.Provider>
  );
}